import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Skeleton from "../h1/skeleton";

const H2Blue = (props) => {
    const { text, color, fontWeight, isLoading } = props;
    let heading = (<h2 styleName={"styles.heading"} style={{ color, fontWeight }}>{text}</h2>);
    if (isLoading) {
        heading = <Skeleton />;
    }
    return heading;
};

H2Blue.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    isLoading: PropTypes.bool,
    fontWeight: PropTypes.string
};

export default H2Blue;
